/**
 * Created by DemonRay on 2019/3/24.
 */

import roundRectangle from '../assets/node-svgs/round-rectangle.svg'
import roundRectangleMagenta from '../assets/node-svgs/round-rectangle-deepblue.svg'
import triangle from '../assets/node-svgs/triangle.svg'
import triangleRed from '../assets/node-svgs/triangle-red.svg'
import ellipse from '../assets/node-svgs/ellipse.svg'
import ellipseGreen from '../assets/node-svgs/ellipseGreen.svg'

import hexagon from '../assets/node-svgs/hexagon.svg'
import star from '../assets/node-svgs/star.svg'
import pentagon from '../assets/node-svgs/pentagon.svg'
import diamond from '../assets/node-svgs/diamond.svg'
import diamondOrange from '../assets/node-svgs/diamond-orange.svg'
import tag from '../assets/node-svgs/tag.svg'
import polygon from '../assets/node-svgs/polygon.svg'
import stickyNote from '../assets/node-svgs/sticky-note.svg'
import institution from '../assets/node-svgs/institution.svg'

import femaleLesbian from '../assets/node-svgs/female-lesbian.svg'
import femaleTrans from '../assets/node-svgs/female-trans.svg'
import femaleBisexual from '../assets/node-svgs/female-bisexual.svg'

import templateKids from '../assets/node-svgs/template-kids.png'
import templateGen from '../assets/node-svgs/template-gen.png'

import maleGay from '../assets/node-svgs/male-gay.svg'
import maleTrans from '../assets/node-svgs/male-trans.svg'
import maleBisexual from '../assets/node-svgs/male-bisexual.svg'
import nonBinary from '../assets/node-svgs/non-binary.svg'

import unknownGender from '../assets/node-svgs/unknown-gender.svg'

import {PartTypeEnum} from "@/tools/IFSMappingParts/PartTypeEnum";
import {
	STICKY_NOTE_BACKGROUND_COLOR,
	STICKY_NOTE_BACKGROUND_OPACITY,
	STICKY_NOTE_BORDER_COLOR,
	STICKY_NOTE_DEFAULT_TEXT,
	STICKY_NOTE_DEFAULT_WIDTH,
	STICKY_NOTE_FONT_SIZE,
	STICKY_NOTE_TYPE,
	getStickyNoteTextWidth
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramStickyNoteHelper";
import {INSTITUTION_TYPE} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramInstitutionHelper";
import {
	getPrimaryPersonLabelMarginY,
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramPrimaryPersonHelper";
import {
	getRenderedGenogramNodeHeight,
	getRenderedGenogramNodeWidth,
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramNodeSizeScaleHelper";

const nodeTypeToImage = {
	'male': roundRectangle,
	'female': ellipse,
	'rectangle': roundRectangle,
	'rectangleMagenta': roundRectangleMagenta,
	'triangle': triangle,
	'triangleRed': triangleRed,
	'ellipse': ellipse,
	'ellipseGreen': ellipseGreen,
	'hexagon': hexagon,
	'star': star,
	'pentagon': pentagon,
	'diamond': diamond,
	'diamondOrange': diamondOrange,
	'tag': tag,
	'polygon': polygon,
	'femaleTrans': femaleTrans,
	'femaleLesbian': femaleLesbian,
	'femaleBisexual': femaleBisexual,
	'maleTrans': maleTrans,
	'maleGay': maleGay,
	'maleBisexual': maleBisexual,
	'template-pair': templateKids,
	'template-generations': templateGen,
	'nonBinary': nonBinary,
	'unknownGender': unknownGender,
	'stickyNote': stickyNote,
	[INSTITUTION_TYPE]: institution,


}

const DEFAULT_NODE_LABEL_MARGIN_Y = 10

const shapeFromType = (type) => {
	type = type || ""
	if(type.startsWith("male") || type.startsWith("rectangle")){
		return 'rectangle'
	}
	if(type.startsWith("female") || type.startsWith("ellipse")){
		return 'ellipse'
	}

	switch (type) {
		case 'rectangle':
			return 'rectangle'
		case 'triangle':
			return 'triangle'
		case 'hexagon':
			return 'hexagon'
		case 'star':
			return 'star'
		case 'pentagon':
			return 'pentagon'
		case 'diamond':
			return 'diamond'
		case 'tag':
			return 'tag'
		case 'nonBinary':
			return 'rectangle'
		case 'unknownGender':
			return 'ellipse'
	}
	return 'ellipse'
}

function mapGenderToNodeType(gender) {
	let normalizedGender = typeof gender === 'string' ? gender.trim() : ""
	if(!normalizedGender){
		return null
	}

	switch (normalizedGender) {
		case "male":
			return "male"
		case "female":
			return "female"
		case "gay":
		case "male_gay":
		case "male-gay":
		case "maleGay":
			return "maleGay"
		case "lesbian":
		case "female_lesbian":
		case "female-lesbian":
		case "femaleLesbian":
			return "femaleLesbian"
		case "male_trans":
		case "male-trans":
		case "maleTrans":
			return "maleTrans"
		case "female_trans":
		case "female-trans":
		case "femaleTrans":
			return "femaleTrans"
		case "male_bisexual":
		case "male-bisexual":
		case "maleBisexual":
			return "maleBisexual"
		case "female_bisexual":
		case "female-bisexual":
		case "femaleBisexual":
			return "femaleBisexual"
		case "non_binary":
		case "non-binary":
		case "nonBinary":
			return "nonBinary"
		case "unknown":
		case "unknown_gender":
		case "unknown-gender":
		case "unknownGender":
			return "unknownGender"
	}

	return null
}

function getPartnerGender(nodeType) {
	let binaryGender = typeof nodeType === 'string' ? nodeType : nodeType.binaryGender
	if(binaryGender === "male"){
		return "female"
	}
	return "male"
}

let opacityFromType = (type) => {
	if(nodeTypeToImage[type] != null) {
		return 0
	}
	return 1
}

const nodeTypesTemplates = [
	{
		type: 'template-pair',
		resize: false,
		category: 'Templates',
		label: "A couple + kids",
		buildIn: true,
		tags: []
	},
	{
		type: 'template-generations',
		resize: false,
		category: 'Templates',
		label: "Multi generations",
		buildIn: true,
		tags: []
	},
]

function getNodeTypesSymbolsOptionsFn(nodeTypesSymbols, filterFn = () => true) {
	let nodeTypeOptions = []
	nodeTypesSymbols.forEach(nodeType => {
		if(filterFn(nodeType)) {
			nodeTypeOptions.push({label: nodeType.label.replaceAll("<br/>", " "), value: nodeType.type})
		}
	})
	return nodeTypeOptions
}

function getNodeTypesSymbolsOptions(filterFn) {
	return getNodeTypesSymbolsOptionsFn(nodeTypesSymbols, filterFn)
}
function getIFSNodeTypesSymbolsOptions(filterFn) {
	return getNodeTypesSymbolsOptionsFn(ifsPartsNodeTypes, filterFn)
}

const nodeTypesSymbols = [
	{
		type: 'male',
		shape: 'rectangle',
		resize: false,
		category: 'Symbols',
		label: "Male",
		binaryGender: "male",
		buildIn: true,
		tags: []
	},
	{
		type: 'female',
		resize: false,
		category: 'Symbols',
		label: "Female",
		binaryGender: "female",
		buildIn: true,
		tags: []
	},

	{
		type: 'maleGay',
		resize: false,
		category: 'Symbols',
		label: "Gay",
		buildIn: true,
		binaryGender: "male",
		tags: []
	},
	{
		type: 'femaleLesbian',
		resize: false,
		category: 'Symbols',
		label: "Lesbian",
		binaryGender: "female",
		buildIn: true,
		tags: []
	},

	{
		type: 'maleTrans',
		resize: false,
		category: 'Symbols',
		label: "Male<br/>Trans",
		buildIn: true,
		binaryGender: "male",
		tags: []
	},
	{
		type: 'femaleTrans',
		resize: false,
		category: 'Symbols',
		label: "Female<br/>Trans",
		buildIn: true,
		binaryGender: "female",
		tags: []
	},
	{
		type: 'maleBisexual',
		resize: false,
		category: 'Symbols',
		label: "Male Bisexual",
		buildIn: true,
		tags: []
	},
	{
		type: 'femaleBisexual',
		resize: false,
		category: 'Symbols',
		label: "Female Bisexual",
		buildIn: true,
		binaryGender: "female",
		tags: []
	},
	{
		type: 'nonBinary',
		resize: false,
		category: 'Symbols',
		label: "Non-binary",
		buildIn: true,
		tags: []
	},


	{
		type: 'triangle',
		shape: 'triangle',
		resize: false,
		label: 'Pregnancy',
		category: 'Symbols',
		buildIn: true
	},
	{
		type: 'unknownGender',
		shape: 'rectangle',
		resize: false,
		label: 'Unknown Gender',
		category: 'Symbols',
		buildIn: true
	},
	{
		type: 'diamond',
		resize: false,
		width: 86,
		height: 78,
		category: 'Symbols',
		label: "Pet",
		buildIn: true
	},
	{
		type: STICKY_NOTE_TYPE,
		resize: true,
		category: 'Extras',
		label: "Note",
		buildIn: true,
		data: {
			noteText: STICKY_NOTE_DEFAULT_TEXT,
			excludeFromLegend: true,
			shape: 'round-rectangle',
			width: STICKY_NOTE_DEFAULT_WIDTH,
			bg: STICKY_NOTE_BACKGROUND_COLOR,
			opacity: STICKY_NOTE_BACKGROUND_OPACITY,
			border: true,
		}
	},
	{
		type: INSTITUTION_TYPE,
		resize: false,
		width: 92,
		height: 92,
		category: 'Extras',
		label: "Institution",
		buildIn: true,
		tags: []
	},

	// {
	// 	type: 'round-rectangle',
	// 	resize: true,
	// 	width: 186,
	// 	height: 78,
	// 	category: 'Extra',
	// 	label: "Text label",
	// 	buildIn: true
	// },

	// {
	//   type: 'diamond',
	//   src: diamond,
	//   bg: '#5CDBD3',
	//   resize: false,
	//   width: 76,
	//   height: 76,
	//   category: '基础形状',
	//   buildIn: true
	// },
	// {
	//   type: 'pentagon',
	//   src: pentagon,
	//   bg: '#722ed1',
	//   resize: false,
	//   width: 76,
	//   height: 76,
	//   category: '基础形状',
	//   buildIn: true
	// },
	// {
	//   type: 'tag',
	//   src: tag,
	//   bg: '#efbae4',
	//   resize: false,
	//   width: 70,
	//   height: 76,
	//   category: '基础形状',
	//   buildIn: true
	// },
	// {
	//   type: 'star',
	//   src: star,
	//   bg: '#00e217',
	//   resize: false,
	//   width: 76,
	//   height: 76,
	//   category: '基础形状',
	//   buildIn: true
	// },
	// {
	//   type: 'hexagon',
	//   src: hexagon,
	//   bg: '#ea9f00',
	//   resize: false,
	//   width: 76,
	//   height: 70,
	//   category: '基础形状',
	//   buildIn: true
	// },
	// {
	//   'type': 'polygon',
	//   'src': polygon,
	//   bg: '#f7130e',
	//   resize: false,
	//   width: 76,
	//   height: 76,
	//   'points': [
	//     -0.33, -1,
	//     0.33, -1,
	//     0.33, -0.33,
	//     1, -0.33,
	//     1, 0.33,
	//     0.33, 0.33,
	//     0.33, 1,
	//     -0.33, 1,
	//     -0.33, 0.33,
	//     -1, 0.33,
	//     -1, -0.33,
	//     -0.33, -0.33
	//   ],
	//   category: '基础形状',
	//   buildIn: true
	// }
]

const defaultNodeTypes = [
	...nodeTypesTemplates,
	...nodeTypesSymbols,
]
const ifsPartsNodeTypes = [

	{
		type: 'ellipse',
		resize: false,
		// width: 76,
		// height: 76,
		category: 'Roles',
		label: "Unknown",
		buildIn: true,
		tags: [],
		data: {
			partType: PartTypeEnum.UNKNOWN,

		},
	},
	{
		type: 'rectangleMagenta',
		resize: false,
		// width: 76,
		// height: 76,
		category: 'Roles',
		label: "Manager",
		buildIn: true,
		tags: [],
		data: {
			partType: PartTypeEnum.PROTECTOR,
		},
	},
	{
		type: 'triangle',
		resize: false,
		// width: 76,
		// height: 76,
		label: 'Firefighter',
		category: 'Roles',
		buildIn: true,
		data: {
			partType: PartTypeEnum.PROTECTOR,
		},

	},
	{
		type: 'diamond',
		resize: false,
		// width: 76,
		// height: 76,
		category: 'Roles',
		label: "Exile",
		buildIn: true,
		data: {
			partType: PartTypeEnum.EXILE,
		},

	},
	{
		type: 'coreSelf',
		shape: 'polygon',
		name: "Self",
		label: "Self",
		resize: false,
		bg: "#0EEA2D",
		border: true,
		opacity: 1,
		width: 176,
		height: 176,
		category: 'Roles',
		buildIn: true,
		tags: [],
		data: {
			isCoreSelf: true,
			isExcluded: false,
			instanceLimit: 1,
			size: 2,
			nonDeletable: false,
			showNotes: true,
		}
	},

]

// Utility function to filter out null and undefined values from an object
const filterValidStyles = (styleObj) =>{
	Object.keys(styleObj).forEach(key => {
		if(styleObj[key] == null){
			delete styleObj[key]
		}
	})
	return styleObj

}

// Function to clean the entire array by applying `filterValidStyles` to each style object
const cleanStyles = (stylesArray) =>{
	for(let i = 0; i < stylesArray.length; i++){
		stylesArray[i].style = filterValidStyles(stylesArray[i].style)
	}
	return stylesArray
}

const compoundDnDStyles = cleanStyles([
	{
		selector: '.cdnd-new-parent',
		style: {
			'border-color': 'red',
			'background-color': 'gray',
			'background-opacity': 0.3,
		}

	},
	{
		selector: '.cdnd-grabbed-node',
		style: {
			'bg': 'red'
		}
	},

	{
		selector: '.cdnd-drop-sibling',
		style: {
			'bg': 'red'
		}
	},

	{
		selector: '.cdnd-drop-target',
		style: {
			'border-color': 'red',
			'border-style': 'dashed'
		}
	}
	])

const defaultNodeStyles = cleanStyles([

	{
		selector: 'node',
		style: {
			'background-opacity': (e) => e.data('bg-opacity') || e.data('opacity') || opacityFromType(e.data('type')),
			'background-color': (e) => e.data('bg') || 'transparent',
			// 'background-image-opacity': (e) => e.active() || e.selected() || e.connectedEdges().some(edge => edge.selected()) ? 1 : 0.2,
			'shape': (e) => e.data('shape') || shapeFromType(e.data('type')),
			'height': (e) => getRenderedGenogramNodeHeight(e.data()),
			'width': (e) => getRenderedGenogramNodeWidth(e.data()),
			'text-valign': 'center',
			'text-halign': 'center',
			'background-fit': 'contain',
			'background-width': '100%',
			'background-height': '100%',
			'background-width-relative-to': 'inner',
			'background-height-relative-to': 'inner',
			'background-position-x': '50%',
			'background-position-y': '50%',
			'background-image': (e) => nodeTypeToImage[e.data('type')] || 'none',


			'border-width': (e) => e.data("border") ? 1 : 0,
			'border-opacity': (e) => e.data("border") ? 0.8 : 0,
			'border-color': (e) => e.data("border") ? e.data('bg') : 'transparent',
		}
	},
	// {
	// 	'selector': 'node[type]',
	// 	'style': {
	// 		'shape': 'data(type)',
	// 		'height': 'data(height)',
	// 		'width': 'data(width)',
	// 		'text-valign': 'center',
	// 		'text-halign': 'center'
	// 	}
	// },
	{
		'selector': 'node[points]',
		'style': {
			'shape-polygon-points': 'data(points)',
			'text-wrap': 'wrap'
		}
	}, {
		'selector': 'node[label]',
		'style': {
			'label': 'data(label)',
			'text-valign': 'bottom',
			'text-halign': 'center',
			'text-margin-y': (e) => getPrimaryPersonLabelMarginY(e.data(), DEFAULT_NODE_LABEL_MARGIN_Y),
			'text-background-color': "#ffffff",
			'text-background-opacity': 0.8,
			'text-background-padding': 5,
			'font-size': 30,
			"text-wrap": "wrap",
			'min-zoomed-font-size': 8
		}
	},
	{
		selector: `node[type="${STICKY_NOTE_TYPE}"]`,
		style: {
			'shape': 'round-rectangle',
			'background-image': 'none',
			'background-color': (e) => e.data('bg') || STICKY_NOTE_BACKGROUND_COLOR,
			'background-opacity': (e) => e.data('opacity') || STICKY_NOTE_BACKGROUND_OPACITY,
			'border-width': 1,
			'border-opacity': 0.9,
			'border-color': (e) => e.data('borderColor') || STICKY_NOTE_BORDER_COLOR,
			'label': 'data(label)',
			'text-valign': (e) => e.data('textVAlign') || 'center',
			'text-halign': 'center',
			'text-margin-y': (e) => e.data('textMarginY') || 0,
			'text-background-opacity': 0,
			'text-wrap': 'wrap',
			'text-max-width': (e) => getStickyNoteTextWidth(e.data('width')),
			'font-size': STICKY_NOTE_FONT_SIZE,
			'min-zoomed-font-size': 6
		}
	},
	// {
	// 	'selector': 'node[image]',
	// 	'style': {
	// 		'background-opacity': 0,
	// 		'background-fit': 'cover',
	// 		'background-image': 'data(src)'
	// 	}
	// },
	// {
	// 	'selector': 'node[bg]',
	// 	'style': {
	// 		'background-opacity': 0.45,
	// 		'background-color': 'data(bg)',
	// 		'border-width': 1,
	// 		'border-opacity': 0.8,
	// 		'border-color': 'data(bg)'
	// 	}
	// },
	{
		selector: 'node.legend-hover-match',
		style: {
			'overlay-opacity': 0,
		}
	},
	{
		selector: 'node.legend-hover-dim',
		style: {
			'opacity': 0.28,
			'text-opacity': 0.42,
		}
	},
	{
		selector: 'node:active',
		style: {
			'overlay-color': '#0169D9',
			'overlay-padding': 12,
			'overlay-opacity': 0.25
		}
	}, {
		selector: 'node:selected',
		style: {
			'overlay-color': '#0169D9',
			'overlay-padding': 12,
			'overlay-opacity': 0.25
		}
	},
	{
		selector: 'node[type="coreSelf"]', // Select nodes where data.type = "coreSelf"
		style: {
			'shape': 'polygon',
			'shape-polygon-points': '0 1, 1 -1, -1 -1', // Upside-down triangle
			'bg-opacity': 0.3,
			'width': 500,
			'height': 500,

		}
	},
	...compoundDnDStyles,
	])

export {
	ifsPartsNodeTypes,
	defaultNodeTypes,
	defaultNodeStyles,
	nodeTypeToImage,
	nodeTypesSymbols,
	nodeTypesTemplates,
	getPartnerGender,
	mapGenderToNodeType,
	shapeFromType,
	getNodeTypesSymbolsOptions,
	getIFSNodeTypesSymbolsOptions,
}
